import { render, staticRenderFns } from "./JNotificationBar.vue?vue&type=template&id=7c27b940&"
import script from "./JNotificationBar.vue?vue&type=script&lang=js&"
export * from "./JNotificationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports